var path = '/login/login_error.tpl.html';
var html = " <div class=\"ifast-login ifds-login-module {{loginErrorCtrl.language}}\" data-ng-if=loginErrorCtrl.isLoaded> <div class=ifast-login-sso-error-logo> <img class=size-auto src=_assets/images/spacer.gif alt=logoTitle /> </div> <div class=ifast-login-error data-ng-bind-html=\"errorMessage | sceTrustAsHtml \"> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./WebContent/src/login/login_error.tpl.html
// module id = 799
// module chunks = 0 2